import {
  isIndustrialMeter,
  isSmartMeter,
  isSmet2,
  isUnknownMeterType,
} from "@/helpers/meterpointHelper"
import { IRegister } from "../meterRegister/meterRegister.types"
import { IMeter } from "./meter.types"

export class Meter implements IMeter {
  constructor(
    public id: number,
    public identifier: string,
    public meterType: string,
    public meterTypeDescription: string,
    public registers: IRegister[],
  ) {}

  get isSmartMeter() {
    return isSmartMeter(this.meterType)
  }

  get isSmet2() {
    return isSmet2(this.meterType)
  }

  get isUnknownMeter() {
    return isUnknownMeterType(this.meterType)
  }

  get isIndustrialMeter() {
    return isIndustrialMeter(this.identifier)
  }
}
